import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {HEADER_STATUS_CODE} from "@core/constants";
import {AuthService} from "@core/authentication/auth.service";
import {environment} from "@environments/environment";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private requestMap = new Map<string, HttpRequest<any>>();

  constructor(
    private authService: AuthService,
  ) {
  }

  private errorPages = [
    HEADER_STATUS_CODE.FORBIDDEN,
    // HEADER_STATUS_CODE.NOT_FOUND,
    HEADER_STATUS_CODE.INTERNAL_SERVER_ERROR
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Ads portal tự xử lý 401 (refresh token) ở AdsAuthInterceptor — không logout phiên Vpage
    if (environment.isAdsModule) {
      return next.handle(request);
    }

    const clonedRequest = request.clone();
    this.requestMap.set(request.urlWithParams, clonedRequest);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error, request)),
      // Final handle remove params
      finalize(() => this.requestMap.delete(request.urlWithParams))
    );
  }

  private handleError(error: HttpErrorResponse, request: HttpRequest<unknown>) {
    // 0. [DEBUG] Log mọi lỗi HTTP để xác định nguyên nhân
    console.log('[ErrorInterceptor] catchError:', {
      url: error.url,
      status: error.status,
      message: error.message,
      name: error.name
    });

    // Kiểm tra có đang ở trang public không — nếu có thì KHÔNG logout
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const isPublicPage = currentPath === '/' || currentPath === '' || currentPath.startsWith('/auth') || currentPath.startsWith('/checkout') || currentPath.startsWith('/pricing');

    // 1. Kiểm tra mã 401 Unauthorized — BE xác nhận user chưa đăng nhập hoặc token hết hạn
    if (error.status === HEADER_STATUS_CODE.UNAUTHORIZED || error.status === HEADER_STATUS_CODE.FOUND) {
      console.warn('[ErrorInterceptor] Nhận mã 401/302 từ BE →', isPublicPage ? 'đang ở trang public, bỏ qua logout' : 'logout', error.url);
      // Không gọi logout từ chính request logout hoặc khi logout đã bắt đầu.
      const isLogoutRequest = request.url.split('?')[0] === environment.baseUrlApi + '/auth/logout';
      if (!isPublicPage && !isLogoutRequest && !this.authService.isLoggingOut) {
        // Báo lý do cho người dùng (hiển thị sau khi logout tải lại trang) thay vì tự đẩy ra không thông báo
        const message = typeof error.error?.message === 'string' && error.error.message
          ? error.error.message
          : 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.';
        this.authService.logout(message);
      }
      return throwError(() => error);
    }

    // 2. JSON parse/network error (status 200/0): không phải tín hiệu session hết hạn.
    // Ví dụ URL API sai có thể trả HTML của SPA; logout ở đây sẽ đá người dùng ra
    // dù request xác thực vẫn hợp lệ. Chỉ ghi log để chẩn đoán.
    if (error.status === 200 || error.status === 0) {
      console.warn(
        '[ErrorInterceptor] Response không parse được (status 200/0) — có thể server trả HTML thay vì JSON',
        {url: error.url, status: error.status, error: error.message}
      );
    }

    return throwError(() => error);
  }

}
